<template>
  <el-dialog
    v-dialogDrag
    :title="'从Excel/XML导入'"
    :visible.sync="uploadFileProps.visible"
    :close-on-click-modal="false"
    width="820px"
    class="small-dialog"
    append-to-body
  >
    <el-steps finish-status="success" :active="uploadFileProps.active" class="mt-20px" align-center>
      <el-step class="text-14px" :title="'下载模板'" @click="downloadTemplate"></el-step>
      <el-step :title="'上传文件'"></el-step>
      <el-step :title="'完成'"></el-step>
    </el-steps>
    <div v-if="uploadFileProps.active === 0" v-loading="uploadFileProps.templateLoading">
      <div class="text-center mt-40px">
        <div class="upload-demo">
          <div
            class="el-upload el-upload--text down-text border border-dashed border-neutral-300 rounded w-490px h-244px"
          >
            <div class="mt-70px">
              <i
                @click="downloadTemplate"
                class="icon iconfont icon-bg-excel h-full text-50px blue-700 text-color-system"
              ></i>
              <!-- text-blue-500 -->
              <div class="el-upload__text mt-10px">
                {{ '点击图标下载模板,填写信息如已下载完成,点击' }}
                <em class="text-color text-color-system" @click="nextStep"> {{ '下一步' }}</em
                ><br />
                {{ '模型文件，可上传模型的XML文件' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="uploadFileProps.active === 1" class="text-center mt-40px mb-4px">
      <el-upload
        v-loading="uploadFileProps.btnLoading"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="true"
        :file-list="fileList"
        :on-remove="handleRemove"
        :on-change="getFileContent"
        :http-request="uploadExcel"
        :multiple="true"
        class="dialog__upload"
      >
        <i class="el-icon-upload text-67px blue-700 text-color-system !mt-70px"></i>
        <div class="el-upload__text">
          {{ '一次只能上传一个excel文件/多个XML(模型)数据文件，或' }}
          <em> {{ '点击上传' }}</em>
        </div>
      </el-upload>
    </div>
    <div class="padding-1" v-show="uploadFileProps.active === 2">
      <div class="text-center mt-40px">
        <div class="upload-demo">
          <div class="el-upload el-upload--text down-text">
            <div class="mt-25px pt-20px">
              <!-- 进度条显示 -->
              <div v-if="isShowProgress" class="w-490px mx-auto mb-40px">
                <el-progress
                  :percentage="currentProgress"
                  :status="currentProgress === 100 ? 'success' : undefined"
                  :stroke-width="20"
                ></el-progress>
                <div class="mt-10px text-center text-14px text-color-system">
                  {{ progressStatus }}
                </div>
              </div>

              <!-- 上传完成结果显示 -->
              <div
                class="mt-30px flex items-center"
                v-if="uploadFileProps.resultFile !== undefined && uploadFileProps.resultFile !== ''"
              >
                <i class="iconfont icon-line-complete text-24px text-green-500"></i>
                <span class="text-20px ml-10px mr-10px">
                  {{
                    `${'上传成功'}！${'成功'}${uploadFileProps.successCount}${'条'}，${'失败'}${
                      uploadFileProps.failureCount
                    }${'条'}`
                  }}
                </span>
                <el-button size="mini" type="primary" @click="exportResults">{{
                  '查看导入结果'
                }}</el-button>
              </div>
              <div
                class="el-upload__text"
                v-else-if="
                  uploadFileProps.resultFile === undefined || uploadFileProps.resultFile === ''
                "
              >
                <div class="mt-25px pt-20px mb-70px">
                  <span class="mt-30px">
                    <i class="iconfont icon-line-complete text-54px text-green-500"></i>
                  </span>
                  <div class="el-upload__text">
                    {{ '上传完成' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="text-center">
      <el-button
        v-if="uploadFileProps.active === 1"
        type="primary"
        size="small"
        @click="uploadFileProps.active = 0"
        :loading="uploadFileProps.btnLoading"
      >
        {{ '上一步' }}</el-button
      >
      <el-button
        v-if="uploadFileProps.active === 2"
        type="primary"
        size="small"
        @click="closeDialog"
        :loading="uploadFileProps.btnLoading"
        >{{ '完成' }}</el-button
      >
      <el-button
        v-if="uploadFileProps.active === 0 || (uploadFileProps.active === 1 && fileList.length > 0)"
        type="primary"
        size="small"
        @click="nextStep"
        :loading="uploadFileProps.btnLoading"
        >{{ '下一步' }}</el-button
      >
      <el-button
        @click="uploadFileProps.active = 1"
        v-if="uploadFileProps.active === 2"
        size="small"
        >{{ '上一步' }}</el-button
      >
      <el-button
        @click="closeDialog"
        v-if="uploadFileProps.active !== 2"
        size="small"
        :loading="uploadFileProps.btnLoading"
      >
        {{ '取消' }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import documentManagementService from '@/services/documentManagement'

export default {
  name: 'upload-xml-file',

  props: {
    /**
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    uploadFileProps: {
      type: Object,
      default: () => {
        return {
          visible: false,
          active: 1,
          btnLoading: false,
          isTestAndVerify: false,
          type: [],
          templateLoading: false,
          maxSize: null,
        }
      },
    },
  },
  data() {
    return {
      file: '',
      fileList: [],
      suffix: false,
      // 进度相关数据
      progressKey: '',
      progressTimer: null,
      currentProgress: 0,
      progressStatus: '',
      isShowProgress: false,
    }
  },
  watch: {},
  methods: {
    // 下载模板
    async downloadTemplate() {
      this.$emit('exportTemplate')
    },
    // 下一步
    async nextStep() {
      // 第二次的下一步，进行提交
      const excelFiles = this.fileList.filter((file) => {
        const ext = file.name
          .split('.')
          .pop()
          .toLowerCase()
        return ext === 'xls' || ext === 'xlsx'
      })
      const xmlFiles = this.fileList.filter((file) => {
        const ext = file.name
          .split('.')
          .pop()
          .toLowerCase()
        return ext === 'xml'
      })
      if (excelFiles.length > 1 || (xmlFiles.length > 0 && excelFiles.length > 0)) {
        this.$message.warning('请按照要求上传文件!')
        return
      }
      if (this.suffix && this.uploadFileProps.active == 1) {
        await this.$emit('importTemplate', this.fileList)
      }
      this.uploadFileProps.active += 1
      if (this.uploadFileProps.active > 2) {
        this.uploadFileProps.active = 1
      }
    },
    // 获取上传的内容并校验格式
    getFileContent(file, fileList) {
      this.file = file
      this.suffix = false
      if (this.uploadFileProps.isTestAndVerify) {
        const format = file.name.substring(file.name.lastIndexOf('.') + 1)
        this.uploadFileProps.type.forEach((item) => {
          if (format === item) {
            this.suffix = true
          }
        })
        if (!this.suffix) {
          this.$message.error(
            `${'文件格式错误，请上传'}${this.uploadFileProps.type.join()}${'文件'}`
          )
          this.fileList = fileList.filter((item) => {
            return item.uid !== file.uid
          })
          return false
        }
      }
      if (this.uploadFileProps.maxSize && this.uploadFileProps.maxSize > 0) {
        const isLimitSize = file.size / 1024 / 1024 < this.uploadFileProps.maxSize
        if (!isLimitSize) {
          this.$message.error(`${'上传文件大小不能超过'} ${this.uploadFileProps.maxSize}MB!`)
          this.fileList = fileList.filter((item) => {
            return item.uid !== file.uid
          })
          return false
        }
      }
      // 仅满足以上条件的文件才会记录
      this.fileList = fileList
      return this.suffix
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    // 上传
    async uploadExcel() {
      // if (this.suffix) {
      //   this.$emit('importTemplate', this.file)
      // }
    },
    exportResults() {
      this.$emit('exportResults')
    },
    // 获取进度
    async getProgress(key) {
      const progressData = await documentManagementService.getDocumentBatchRelationProgress(key)
      this.currentProgress = progressData.currentProgress
      this.progressStatus = progressData.status
      // 检查是否完成
      if (progressData.isCompleted) {
        this.stopProgressTimer()
      }
    },

    // 开始定时获取进度
    startProgressTimer(key) {
      this.progressKey = key
      this.isShowProgress = true
      this.currentProgress = 0

      // 立即获取一次进度
      this.getProgress(key)

      // 设置5秒定时器
      this.progressTimer = setInterval(() => {
        this.getProgress(key)
      }, 5000)
    },

    // 停止定时获取进度
    stopProgressTimer() {
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
    },

    // 设置进度key（用于父组件传递）
    setProgressKey(key) {
      this.startProgressTimer(key)
    },

    // 关闭弹窗并重新请求列表
    closeDialog() {
      this.$emit('refreshList')
      this.uploadFileProps.active = 1
      this.file = ''
      this.fileList = []
      this.uploadFileProps.visible = false
      this.stopProgressTimer()
    },
  },

  // 组件销毁时清理定时器
  beforeDestroy() {
    this.stopProgressTimer()
  },
}
</script>

<style scoped lang="scss">

.dialog__upload {
  ::v-deep .el-step.is-simple {
    .el-step__title {
      font-size: 15px !important;
    }
  }
  ::v-deep .el-upload-dragger {
    height: 244px !important;
    width: 490px !important;
  }
}
.small-dialog ::v-deep .el-dialog,
.el-dialog__body,
.dialog__upload {
  height: auto !important;
}
.mt-40px {
  margin-top: 40px;
}
.mb-70px {
  margin-bottom: 70px;
}

</style>
